import api from "@/composables/api";
import { useUser } from "@/stores";

export default () => {
  const userStore = useUser();

  const connectStripe = () => {
    const clientId = import.meta.env.VITE_APP === "production" ? 
      import.meta.env.VITE_APP_STRIPE_LIVE_CLIENT_ID : import.meta.env.VITE_APP_STRIPE_TEST_CLIENT_ID;
    const redirectUri = import.meta.env.VITE_APP === "production" ?
      import.meta.env.VITE_APP_STRIPE_LIVE_URI : import.meta.env.VITE_APP_STRIPE_TEST_URI;
    api(`v1/stripe/uri`)
      .then((res) => {
        const url = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${
          clientId
        }&redirect_uri=${redirectUri}&state=${
          res.data.uriHash
        }&scope=read_write`;
        const windowName = "Popup"; // Optional name for the window
        const windowFeatures = "width=400,height=800";
        const popupWindow = window.open(url, windowName, windowFeatures);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const disconnectStripe = () => {
    api(`v1/stripe/disconnect`)
      .then((res) => {
        userStore.setSettings(res.data.userSettings);
      })
      .catch((err) => {
        // console.log("err", err);
      });
  };

  const chargeStripe = async (data) => {
    return await api(`v1/stripe/charge/`, {
      method: "POST",
      body: data,
    });
  };

  return {
    connectStripe,
    disconnectStripe,
    chargeStripe,
  };
};
